import { render, staticRenderFns } from "./BlocoVisualizarRelatorio.vue?vue&type=template&id=6f7bf989&lang=pug"
import script from "./BlocoVisualizarRelatorio.vue?vue&type=script&lang=js"
export * from "./BlocoVisualizarRelatorio.vue?vue&type=script&lang=js"
import style0 from "./BlocoVisualizarRelatorio.vue?vue&type=style&index=0&id=6f7bf989&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports